import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatShortDate, isSameDay, startOfLocalDay } from "@/lib/date";

interface DateNavigationProps {
  currentDate: Date;
  onPrevious: () => void;
  onNext: () => void;
  onDateClick: () => void;
}

export function DateNavigation({ currentDate, onPrevious, onNext, onDateClick }: DateNavigationProps) {
  const today = startOfLocalDay(new Date());
  const selectedDay = startOfLocalDay(currentDate);
  const disableNext = selectedDay >= today;

  return (
    <div className="sticky top-0 z-50 flex items-center justify-between border-b border-[var(--color-border-subtle)] bg-[var(--color-bg-elevated)] px-3 py-4">
      <button
        onClick={onPrevious}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-[var(--color-text-secondary)] transition-colors duration-[var(--transition-base)] hover:bg-[var(--color-bg-hover)] active:bg-[var(--color-bg-active)]"
        aria-label="Previous day"
      >
        <ChevronLeft size={22} strokeWidth={1.75} />
      </button>

      <button
        onClick={onDateClick}
        className="mx-2 flex-1 rounded-lg px-4 py-2 text-center transition-colors duration-[var(--transition-base)] hover:bg-[var(--color-bg-hover)] active:bg-[var(--color-bg-active)]"
        aria-label="Choose date"
      >
        <div className="mb-0.5 text-xs font-medium uppercase tracking-[0.08em] text-[var(--color-text-tertiary)]">
          Migraine Tracker
        </div>
        <div className="text-xl text-[var(--color-text-primary)]">{formatShortDate(currentDate)}</div>
        {isSameDay(currentDate, new Date()) && (
          <div className="mt-0.5 text-sm text-[var(--color-text-tertiary)]">Today</div>
        )}
      </button>

      <button
        onClick={onNext}
        disabled={disableNext}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-[var(--color-text-secondary)] transition-colors duration-[var(--transition-base)] hover:bg-[var(--color-bg-hover)] active:bg-[var(--color-bg-active)] disabled:cursor-not-allowed disabled:opacity-30"
        aria-label="Next day"
      >
        <ChevronRight size={22} strokeWidth={1.75} />
      </button>
    </div>
  );
}
